// extracted by mini-css-extract-plugin
export default {"container":"FilterBlockListItem-module__container___L_p0w","label":"FilterBlockListItem-module__label___KRKYZ","checkbox":"FilterBlockListItem-module__checkbox___CgXCP"};